/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Empty_Title1Inputs */

const en_coinvestments_insights_empty_title1 = /** @type {(inputs: Coinvestments_Insights_Empty_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No insights yet`)
};

/**
* | output |
* | --- |
* | "No insights yet" |
*
* @param {Coinvestments_Insights_Empty_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_empty_title1 = /** @type {((inputs?: Coinvestments_Insights_Empty_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Empty_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_empty_title1(inputs)
});
export { coinvestments_insights_empty_title1 as "coInvestments_insights_empty_title" }